import React from 'react';
import { createBrowserRouter, Outlet, RouterProvider } from 'react-router-dom';
import { I18nextProvider } from 'react-i18next';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';

import { Providers } from '../components/Providers';
import { Redirect } from '../components/Redirect';
import { Root } from '../components/Root';
import { Init } from '../components/Init';
import { Layout } from '../components/Layout';
import { ProviderResetBoundary } from '../components/ProviderResetBoundary';

import { Reporti18nInstance } from '../i18n/configs';

import { Report } from './Report';
import { ReportDetail } from './ReportDetail';
import { NotFound } from './NotFound';
import { Error } from './Error';
import { Initialize } from './Initialize';

import { PAGE_PATH } from '../constants';

import { ConfirmProvider } from '../contexts/Confirm';
import { InfoDialogProvider } from '../contexts/InfoDialog';
import { ShowLoadingProvider } from '../contexts/ShowLoading';
import { CustomClaimsProvider } from '../services/store/CustomClaims';
import { ErrorProvider } from '../services/store/Error';

const router = createBrowserRouter([
  {
    path: PAGE_PATH.ROOT,
    element: (
      <ProviderResetBoundary>
        <Outlet />
      </ProviderResetBoundary>
    ),
    children: [
      {
        ErrorBoundary: Error,
        children: [
          {
            index: true,
            element: <Redirect />,
          },
          {
            path: PAGE_PATH.DETAIL,
            element: <ReportDetail />,
          },
          {
            path: PAGE_PATH.EDIT,
            element: <Report />,
          },
          {
            path: PAGE_PATH.INITIALIZE,
            element: <Initialize />,
          },
        ],
      },
    ],
  },
  {
    path: '/error',
    element: <Error />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
]);

/**
 * 初期設定ファイル
 * ルーティングなどの設定を担う初回に呼ばれるファイル
 * @returns JSX
 */
export function App(): React.JSX.Element {
  return (
    <DndProvider backend={HTML5Backend}>
      <Providers>
        <I18nextProvider i18n={Reporti18nInstance}>
          <Init>
            <CustomClaimsProvider>
              <ShowLoadingProvider>
                <ConfirmProvider>
                  <InfoDialogProvider>
                    <ErrorProvider>
                      <Root>
                        <Layout>
                          <RouterProvider router={router} />
                        </Layout>
                      </Root>
                    </ErrorProvider>
                  </InfoDialogProvider>
                </ConfirmProvider>
              </ShowLoadingProvider>
            </CustomClaimsProvider>
          </Init>
        </I18nextProvider>
      </Providers>
    </DndProvider>
  );
}
